// src/services/api/auth.js
import { apiClient } from './base';

export const signupUser = async (userData) => {
  try {
    const response = await apiClient.post('/auth/signup', userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const loginUser = async (credentials) => {
  try {
    const response = await apiClient.post('/auth/login', credentials);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const logoutUser = async () => {
  try {
    const response = await apiClient.post('/auth/logout');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await apiClient.post('/auth/forgot-password', { email });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (token, password) => {
  try {
    const response = await apiClient.post('/auth/reset-password', { 
      token, 
      password 
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyToken = async () => {
  try {
    const response = await apiClient.get('/auth/verify');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const refreshToken = async () => {
  try {
    const response = await apiClient.post('/auth/refresh');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyEmail = async (data) => {
  try {
    const response = await apiClient.post('/auth/verify-email', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resendVerificationEmail = async (data) => {
  try {
    const response = await apiClient.post('/auth/resend-verification', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const changeEmail = async (data) => {
  try {
    const response = await apiClient.post('/auth/change-email', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};